/* eslint-disable no-unused-vars */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import TransparentBlogCard from "reusables/Cards/BlogCards/TransparentBlogCard";

// Images
import block1 from "assets/images/Services/Block/block1.jpg";
import block2 from "assets/images/Services/Block/block2.jpg";

function Block_Section1() {
  return (
    <Container>
      <SubTitleContents
        title="Why Choose Our Block Management?"
        contents="Our Block Management service is designed for multi-unit properties and apartment complexes. We ensure all common areas are well-maintained, financial matters are managed efficiently, and residents’ concerns are addressed promptly."
      />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard image={block1} />
        </Grid>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard image={block2} />
        </Grid>
        <Grid item xs={12} sm={6} lg={4} textAlign="justify" wordbreak="break-all">
          <TransparentBlogCard image={block2} />
        </Grid>
      </Grid>

      {/* <Grid container alignItems="center" width={"100%"}>
              <Grid item xs={12} lg={6}>
                <MKBox
                  component="img"
                  src={multiUnit}
                  alt={"Multi Unit Property"}
                  width="100%"
                  // pl={5}
                  pr={1}
                  position="relative"
                />
              </Grid>
              <Grid item xs={12} lg={6}>
                <MKBox
                  component="img"
                  src={apartment}
                  alt={"Multi Unit Property"}
                  width="100%"
                  pl={1}
                  position="relative"
                />
              </Grid>
              <Grid item xs={12} lg={12} height={"1500px"}>
                <BackgroundBlogCard
                  image={multiUnit}
                  title="Tailored Cleaning Plans"
                  description="Our Block Management service is designed for multi-unit properties and apartment complexes. We ensure all common areas are well-maintained, financial matters are managed efficiently, and residents’ concerns are addressed promptly."
                  action={{
                    type: "internal",
                    route: "/",
                    label: "read more",
                  }}
                  // popular={false}
                />
              </Grid>
            </Grid> */}
    </Container>
  );
}

export default Block_Section1;
